import React, { useState } from "react";
import demo3 from "../../assets/documents/GR.pdf";
import demo4 from "../../assets/documents/MOU.pdf";
import demo2 from "../../assets/documents/Gad_Samvardhan_Yojana.pdf";
import demo1 from "../../assets/documents/Maharashtra_Vaibhav_State_Protected_Monument_Care_Scheme.pdf";
import { FaFilePdf } from "react-icons/fa";
import { useSelector } from "react-redux";
import { convertToMarathiNumber } from "../../components/marathiNumbers";
import { Link } from "react-router-dom";

const Scheme = () => {
  const [activeTab, setActiveTab] = useState("gad");
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const tabs = [
    {
      key: "gad",
      label: {
        English: "Gad Sanvardhan",
        मराठी: "गड संवर्धन",
      },
    },
    {
      key: "adopt",
      label: {
        English: "Adopt the Monument",
        मराठी: "महाराष्ट्र वैभव राज्य संरक्षित स्मारक संगोपन योजना",
      },
    },
  ];

  const content = {
    English: {
      title: "Schemes & Projects",
      breadcrumb: {
        home: "HOME",
        page: "SCHEMES & PROJECTS",
      },
      heading: `Gad Sanvardhan Yojana and Monument Conservation Scheme`,
      heading1: `Adopt the Monument`,
      paragraph: `Forts and Monuments being a living testimony to our glorious heritage need to be conserved and preserved. Forts in Maharashtra are evidences of the brilliance of Chhatrapati Shivaji Maharaj as a King and an administrator. His legacy, through the forts and fortresses is a great way to introduce his life and works to the younger generation. The Government of Maharashtra and the Directorate of Archaeology and Museums with an aim to conserve, preserve, educate and involve the masses, scholars and laymen alike as well as experts and organisations/NGOs; the Gad Samvardhan Yojana and Monument Conservation Scheme was introduced as per   Government Resolution No. Miscellaneous 2014/P.No.156/No.3, dated 30.03.2015. As per this, a committee was  formed under the chairmanship of Minister, Cultural Affairs, Government of Maharashtra. This committee had recommended for the preservation and conservation of a total of 28 forts in the state, out of which preservation and conservation of 24 forts has been completed. The conservation work of Shirgaon Fort and Underi Fort has been currently suspended and the work of the remaining 2 forts is in progress.`,
      paragraph1: `Currently, the Fort Conservation Committee has been re-established as per the Government Resolution dated 30.11.2022 of the Department of Tourism and Cultural Affairs. Under this committee, state level and department level committees have been formed like the revenue departments of Maharashtra State. Conservation work of Forts and Fortresses in Maharashtra can be proposed under the guidance of this committee. In this committee constituted by the government; based on the  recommendations of the department level committee vetted through the state level committee, district level information of unprotected forts and fortresses in the state is prepared, advice regarding the comprehensive development plans is provided, various activities are organized, and appropriate measures are taken to increase the participation of local people for the conservation of the forts. As per the Government Resolution No. DAP/10/2022/Pr.No.277/Ka.1481, dated 14.12.2022 of the Planning Department, District Annual Plan (General) includes forts, temples and important monuments in the state.`,
      paragraph2: `The department level committee collects comprehensive information about the forts under  the concerned department. After this with the cooperation of the concerned Archaeology Divisional Office, a district wise Gazetteer is prepared. They also recommend the Forts needing repair, conservation and preservation to the State level committee. There is also a tourism development program which gives recommendations to the Government to increase participation and engagement of local groups as well as NGOs and organisations and how to increase employment and business opportunities in the area of such forts and monuments. `,
      // paragraph3: `The departmental level committee to collect comprehensive information about the forts in the concerned department and to cooperate with the concerned archeology divisional office to prepare the district wise gazetteer, to recommend to the state level committee regarding the preservation and repair and conservation work of the forts in department wise, the tourism development program includes activities such as making recommendations to the government on how to increase the participation of local savings groups, related NGOs working at the fort and local people living in the area in employment growth.`,
      paragraph4: `Adopt a Monument is a scheme launched with an aim to create awareness amongst laymen about historical heritage and for an active participation by Non-Government organizations/persons directly into the conservation and restoration of the Monuments Protected by the state under the “Maharashtra Vaibhav Rajya Swanrakshit Smarak Sangopan Yojana” w.e.f. 02nd February 2007 by GR. No. PQ.107/cul-3.`,
      paragraph5: `Any organization/s/person can adopt the Monuments scheduled in the protected Monuments list of Maharashtra State for five years through the 2007 GR. However, due to interest of public and NGO’s, the government has decided to extend adoption limit up to 10 years through which conservation, day to day maintenance, security, etc. shall be the responsibilities of organizations/persons who adopt the Monument/s.`,
      paragraph6: `Under this scheme, proposal of adapting Naldurg fort, Naldurg, Taluka Tuljapur District Dharashiv by Unity Multicans Pvt. Ltd. Solapur has had been approved by the Maharashtra Government. The first phase of work mentioned in the proposal have been undertaken by Unity Multicans Pvt. Ltd. Solapur  `,
      paragraph7: `The birthplace of Late Shri Yashwantrao Chavan, the first Chief Minister of Maharashtra State at Devrashtre in Taluka Kadegaon, District Sangli has been adopted by Yashwantrao Chavan Pratishthan, Mumbai. They have exhibited important events in the life of Late Shri. Yashwantrao Chavan here through photographs.`,
      tableHeading1: `Stage 1`,
      tableHeading2: `Stage 2`,
    },
    मराठी: {
      title: "योजना आणि प्रकल्प",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "योजना आणि प्रकल्प",
      },
      heading: `गड संवर्धन व स्मारक जतन योजना`,
      heading1: `महाराष्ट्र वैभव राज्य संरक्षित स्मारक संगोपन योजना`,
      paragraph: `गड किल्ल्यांचे संवर्धन चांगल्या प्रकारे व्हावे व त्यासाठी दुर्गप्रेमी संस्थांचा, व्यक्तींचा आणि दुर्ग तंज्ञाचा सहभाग मिळावा तसेच छत्रपती शिवाजी महाराजांच्या प्रेरणादायी जीवनाची नवीन पिढीला ओळख करुन देण्यासाठी आणि गड व किल्ले यांचे जतन-संवर्धन करण्यासाठी शासन निर्णय क्र. संकीर्ण 2014/प्र.क्र.156/सां.का.3, दि. 30.03.2015 याद्वारे तत्कालीन मा. मंत्री, सांस्कृतिक कार्य यांच्या अध्यक्षतेखाली इतिहास प्रेमी यांची समिती गठित केली होती. या समितीने राज्यातील एकुण 28 किल्ल्यांची जतन व संवर्धनासाठी शिफारशी केली होती. त्यापैकी 24 किल्ल्यांची कामे पुर्ण झाली आहेत. शिरगाव किल्ला उंदेरी किल्ला या किल्ल्यांच्या जतन संवर्धनाचे काम स्थगित करण्यात आले असुन उर्वरित 2 किल्ल्यांचे कामप्रगतिपथावर आहे.`,
      paragraph1: `सद्यस्थितीत पर्यटन व सांस्कृतिक कार्य विभाग शासन निर्णय दि. 30.11.2022 अन्वये गड संवर्धन समितीची पुर्नस्थापना करण्यात आली. या समितीमध्ये राज्यस्तरीय व महाराष्ट्र राज्याच्या महसुल विभागांप्रमाणे विभागास्तरीय समिती तयार करण्यात आली आहे. यासमितीच्या मार्गदर्शनाखाली महाराष्ट्रातील गडकोटांच्या संवर्धनाचे काम प्रस्तावित करता येईल.`,
      paragraph2: `शासने गठित केलेल्या या समितीमध्ये राज्यस्तरीय समितीद्वारे विभागस्तरीय समितीच्या शिफारशींनुसार राज्यातील असंरक्षित गड, किल्ल्यांची जिल्हानिहाय माहिती तयार करणे, सर्वंकष विकास आराखड्यांसदर्भात सल्ला देणे, विविध उपक्रमांचे आयोजन करणे, विभागस्तरीय समितीच्या सहकार्याने गड कोटांच्या संवर्धनासाठी स्थानिक लोकांचा सहभाग वाढविण्याची उपाययोजना करणे या स्वरुपाच्या कार्यांचा समावेश आहे. राज्यातील संरक्षित स्मारके ज्यात गडकिल्ले, मंदिरे, लेणी इ. चा समावेश आहे. त्यासाठी सांस्कृतिक कार्य विभागाच्या विनंतीनुसार नियोजन विभागाने शासन निर्णय क्र. डॅप/१०/२०२२/प्र.क्र.२७७/का.१४८१, दि. १४.१२.२०२२ रोजीच्या शासन निर्णयानुसार जिल्हा वार्षिक योजना (सर्वसाधारण) यातून राज्यातील गडकिल्ले, मंदिरे व महत्त्वाचे स्मारके यांच्या जतन-संवर्धनासाठी ३ टक्के निधीची तरतूद आहे`,
      paragraph3: `विभागस्तरीय समितीने संबंधित विभागातील गड-कोटांविषयी सर्वंकष माहिती गोळा करणे व जिल्हानिहाय गॅझेटिअर तयार करण्यासाठी संबंधित पुरातत्त्व विभागीय कार्यालयास सहकार्य करणे, विभाग निहाय किल्ल्यांच्या जतन व दरुस्ती व संवर्धन कार्याबाबत राज्यस्तरीय समितीला शिफारस करणे, पर्यटन विकास कार्यक्रमात स्थानिक बचतगट, किल्ल्यावर काम करणाऱ्या संबंधित स्वयंसेवी संस्था व परिसरात राहणारे स्थानिक लोक यांचा रोजगार वाढीस कसा सहभाग वाढविता येईल याविषयी शासनास शिफारशी करणे या स्वरुपाच्या कार्यांचा समावेश आहे.`,
      // paragraph4: `विभागस्तरीय समितीने संबंधित विभागातील गड-कोटांविषयी सर्वंकष माहिती गोळा करणे व जिल्हानिहाय गॅझेटिअर तयार करण्यासाठी संबंधित पुरातत्त्व विभागीय कार्यालयास सहकार्य करणे, विभाग निहाय किल्ल्यांच्या जतन व दरुस्ती व संवर्धन कार्याबाबत राज्यस्तरीय समितीला शिफारस करणे, पर्यटन विकास कार्यक्रमात स्थानिक बचतगट, किल्ल्यावर काम करणाऱ्या संबंधित स्वयंसेवी संस्था व परिसरात राहणारे स्थानिक लोक यांचा रोजगार वाढीस कसा सहभाग वाढविता येईल याविषयी शासनास शिफारशी करणे या स्वरुपाच्या कार्यांचा समावेश आहे.`,
      paragraph5: `ऐतिहासिक वारशाबद्दल सामान्य माणसामध्ये जागरुकता निर्माण करण्याच्या उद्देशाने 'महाराष्ट्र वैभव राज्य स्वरक्षित स्मारक संगोपन योजना' 02 फेब्रुवारी 2002 अंतर्गत राज्याद्वारे संरक्षित स्मारकांच्या संवर्धन आणि जीर्णोद्धारात अशासकीय संस्था/व्यक्तींचा थेट सक्रिय सहभाग या साठी शासन निर्णय 2007. क्रमांक PQ.107/cul-3, महाराष्ट्र राज्याने घोषित केला.`,
      paragraph6: `कोणतीही संस्था/व्यक्ती 2007 च्या शासन निर्णयाद्वारे पाच वर्षांसाठी पुरातत्त्व व वस्तुसंग्रहालये संचालनालय, महाराष्ट्र राज्याच्या संरक्षित स्मारकांच्या अनुसूचित यादीमधील स्मारके दत्तक घेऊ शकतात. तथापि, सार्वजनिक आणि स्वयंसेवी संस्थांच्या विनंतीनुसार सरकारने अनुकूलन मर्यादा 10 वर्षांपर्यंत वाढवण्याचा निर्णय घेतलाज्याद्वारे संवर्धन, दैनंदिन देखभाल, सुरक्षा, जतन  इत्यादी हे स्मारक दत्तक घेणाऱ्या  संस्था/व्यक्तीच्या जबाबदाऱ्या आहेत.`,
      paragraph7: `या योजनेंतर्गत नळदुर्ग, ता. तुळजापूर, धाराशिव येथील नळदुर्ग किल्ल्याला दत्तक घेण्याच्या युनिटी मल्टीकन्स प्रा.लि.सोलापूरला यांच्या प्रस्तावास शासनाने मान्यता दिली आहे. `,
      paragraph8: `मा. कै.श्री. यशवंतराव चव्हाण, महाराष्ट्राचे पहिले मुख्यमंत्री यांचे जन्मस्थान म्हणजे देवराष्ट्रे, कडेगाव, जिल्हा सांगली हे सुद्धा यशवंतराव चव्हाण प्रतिष्ठान, मुंबई यांनी दत्तक घेतले आहे. इथे त्यांनी यशवंतराव चव्हाण यांच्या जीवनातील महत्त्वाच्या घटना छायाचित्रांच्या माध्यमातून प्रदर्शित केल्या आहेत.`,
      tableHeading1: `टप्पा १`,
      tableHeading2: `टप्पा २`,
    },
  };
  const t = content[selectedLang];
  const tableHeaders = {
    srNo: {
      id: 1,
      English: "Sr. No.",
      मराठी: "अ.क्र.",
    },
    division: {
      id: 2,
      English: "Division",
      मराठी: "विभाग",
    },
    monument: {
      id: 3,
      English: "Name of Monument",
      मराठी: "स्मारकाचे नाव",
    },
    scheme: {
      id: 4,
      English: `Schemes`,
      मराठी: `योजना`,
    },
    download: {
      id: 5,
      English: `Downloads`,
      मराठी: `डाउनलोड`,
    },
  };

  const stage1Data = [
    {
      id: 1,
      division: {
        English: "Ratnagiri",
        मराठी: "रत्नागिरी",
      },
      monument: {
        English: "Shirgaon Fort, Shirgaon, Dist. Palghar",
        मराठी: "शिरगाव किल्ला, शिरगाव, ता. जि. पालघर",
      },
    },
    {
      id: 2,
      division: {
        English: "Pune",
        मराठी: "पुणे",
      },
      monument: {
        English:
          "Bhudargad Fort, Bhudargad, Dist. Kolhapur.\n Torna Fort, Velha, Dist. Pune",
        मराठी:
          "भुदरगड किल्ला, भुदरगड, जि. कोल्हापूर.\nतोरणा किल्ला, वेल्हा, जि. पुणे",

      },
    },
    {
      id: 3,
      division: {
        English: "Nashik",
        मराठी: "नाशिक",
      },
      monument: {
        English:
          "Kharda Fort, Kharda, Dist. Ahilyanagar. \n Galana Fort, Galana, Dist. Nashik",
        मराठी:
          "खर्डा किल्ला, खर्डा, जि. अहिल्यनगर.\n गाळणा किल्ला, ता. मालेगाव, जि. नाशिक",
      },
    },
    {
      id: 4,
      division: {
        English: "Nagpur",
        मराठी: "नागपूर",
      },
      monument: {
        English:
          "Ambagad Fort, Ambagad, Dist. Bhandara \n Manikgad Fort, Manikgad, Dist. Chandrapur \n Nagardhan Fort, Ramtek, Dist. Nagpur",
        मराठी:
          "अंबागड किल्ला, अंबागड, जि. भंडारा, \n मानिकगड किल्ला, मानिकगड, जि. चंद्रपूर, \n नगरधान किल्ला, रामटेक, जि. नागपूर",
      },
    },
    {
      id: 5,
      division: {
        English: "Chhatrapati Sambhaji Nagar",
        मराठी: "छत्रपती संभाजी नगर",
      },
      monument: {
        English:
          "Antur Fort, Nagapur, Dist. Chhatrapati Sambhaji Nagar, \n Paranda Fort, Paranda, Dist. Osmanabad, \n Dharur Fort, Dharur, Dist. Beed",
        मराठी:
          "अंतूर किल्ला, नागापूर, जि. छत्रपती संभाजी नगर, \n परंडा किल्ला, परंडा, जि. उस्मानाबाद, \n धारूर किल्ला, धारूर, जि. बीड",
      },
    },
    {
      id: 6,
      division: {
        English: "Nanded",
        मराठी: "नांदेड",
      },
      monument: {
        English:
          "Ausa Fort, Ausa, Dist. Latur, \n Kandhar Fort, Kandhar, Dist. Nanded, \n Mahur Fort, Mahur, Dist. Nanded",
        मराठी:
          "औसा किल्ला, औसा, जि. लातूर, \n कंधार किल्ला, कंधार, जि. नांदेड, \n माहूर किल्ला, माहूर, जि. नांदेड",
      },
    },
  ];

  const stage2Data = [
    {
      id: 1,
      division: {
        English: "Ratnagiri",
        मराठी: "रत्नागिरी",
      },
      monument: {
        English:
          "Purngad Fort, Purngad, Dist. Ratnagiri, \n Bankot Fort, Bankot, Dist. Ratnagiri, \n Underi Fort, Underi, Dist. Raigad, \n Yashwantgad Fort, Redi, Dist. Sindhudurga, \n Bharatgad Fort, Masure, Dist. Sindhudurga",
        मराठी:
          "पूर्णगड किल्ला, पूर्णगड, जि. रत्नागिरी, \n बांकोट किल्ला, बांकोट, जि. रत्नागिरी, \n उंदेरी किल्ला, उंदेरी, जि. रायगड, \n यशवंतगड किल्ला, रेडी, जि. सिंधुदुर्ग, \n भारतगड किल्ला, मासुरे, जि. सिंधुदुर्ग",
      },
    },
    {
      id: 2,
      division: {
        English: "Pune",
        मराठी: "पुणे",
      },
      monument: {
        English:
          "Koyrigad Fort, Ambavane, Dist. Pune, \n Rangana Fort, Chickewadi, Dist. Kolhapur, \n Vishalgad Fort, Gajapur, Dist. Kolhapur",
        मराठी:
          "कोयरीगड किल्ला, अंबावणे, जि. पुणे, \n रांगणा किल्ला, चिकेवाडी, जि. कोल्हापूर, \n विशाळगड किल्ला, गजापूर, जि. कोल्हापूर",
      },
    },
    {
      id: 3,
      division: {
        English: "Nashik",
        मराठी: "नाशिक",
      },
      monument: {
        English:
          "Ankai Fort, Ankai, Dist. Nashik, \n Tankai Fort, Ankai, Dist. Nashik, \n Salher Fort, Mulher, Dist. Nashik, \n Mulher Fort, Mulher, Dist. Nashik, \n Laling Fort, Laling, Dist. Dhule",
        मराठी:
          "अंकाई किल्ला, अंकाई, जि. नाशिक, \n टंकाई किल्ला, अंकाई, जि. नाशिक, \n सल्हेर किल्ला, मुल्हेर, जि. नाशिक, \n मुल्हेर किल्ला, मुल्हेर, जि. नाशिक, \n लालिंग किल्ला, लालिंग, जि. धुळे",
      },
    },
    {
      id: 4,
      division: {
        English: "Chhatrapati Sambhaji Nagar",
        मराठी: "छत्रपती संभाजी नगर",
      },
      monument: {
        English: "Vetalwadi Fort, Vetalwadi, \n  Dist. Chhatrapati Sambhaji Nagar",
        मराठी: "वेताळवाडी किल्ला, वेताळवाडी, \n  जि. छत्रपती संभाजी नगर",
      },
    },
  ];

  const downloadData = [
    {
      id: 1,
      schemas: {
        English: "Maharashtra Vaibhav State Protected Monument Care Scheme",
        मराठी: "महाराष्ट्र वैभव राज्य संरक्षित स्मारक संगोपन योजना",
      },
      download: demo1,
    },

    {
      id: 2,
      schemas: {
        English: "Gad Samvardhan Yojana",
        मराठी: "गड संवर्धन व स्मारकाचे जतन योजना",
      },
      download: demo2,
    },
  ];

  const schemasData = [
    { id: 1, schemas: "Memorandum_of_Understanding Prototype", download: demo3 },
    { id: 2, schemas: "Adopt the Monument GR", download: demo4 },
  ];

  return (
    <div className="px-4 py-12">
      {/* Title */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div>
      <div className="flex justify-center space-x-4 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={` no-dark-bg tab-button  border border-orange-500  font-futura px-4 py-2 rounded ${activeTab === tab.key ? "active-tab"
                : "hover:bg-[#DD9827] hover:text-white border-[#DD9827]"
              }`}
          >
            {tab.label[selectedLang]}
          </button>
        ))}
      </div>
      {activeTab === "gad" && (
        <div>
          <div className="text-left mx-auto md:mx-16">
            <h3 className="text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-8 mt-12">
              {t.heading}
            </h3>
            <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify mb-4 font-futura">
              {t.paragraph}
            </p>
            <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify mb-4 font-futura">
              {t.paragraph1}
            </p>
            <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify mb-4 font-futura">
              {t.paragraph2}
            </p>
            <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify mb-4 font-futura">
              {t.paragraph3}
            </p>
            {/* Stage 1 */}
            <h2 className="text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-8 mt-12">
              {t.tableHeading1}
            </h2>
            <div className="max-w-4xl mx-auto">
              <div
                className="bg-[#EFE DE0] rounded-xl overflow-x-auto border"
                style={{ border: "2px solid #F8D6BF" }}
              >
                <table className="min-w-full text-center text-black text-sm sm:text-base">
                  <thead
                    className="font-bold tracking-wide"
                    style={{
                      textShadow: "0.3px 0.3px 0 black",
                    }}
                  >
                    <tr>
                      <th
                        className="py-3 px-4 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {tableHeaders.srNo[selectedLang]}
                      </th>
                      <th
                        className="py-3 px-4 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {tableHeaders.division[selectedLang]}
                      </th>
                      <th
                        className="py-3 px-4"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {tableHeaders.monument[selectedLang]}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {stage1Data.map((item, index) => (
                      <tr key={item.id}>
                        <td
                          className="py-3 px-4 border-t-2 border-r-2"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          {selectedLang === "मराठी"
                            ? convertToMarathiNumber(index + 1)
                            : `${index + 1}`}
                          .
                        </td>
                        <td
                          className="py-3 px-4 border-t-2 border-r-2"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          {item.division[selectedLang]}
                        </td>
                        <td
                          className="py-3 px-4 border-t-2 whitespace-pre-line"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          {item.monument[selectedLang]}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Stage 2 */}
            <h2 className="text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-8 mt-12">
              {t.tableHeading2}
            </h2>
            <div className="max-w-4xl mx-auto">
              <div
                className="bg-[#EFEDE0] rounded-xl overflow-x-auto"
                style={{ border: "2px solid #F8D6BF" }}
              >
                <table className="min-w-full text-center text-black text-sm sm:text-base">
                  <thead
                    className="font-bold tracking-wide"
                    style={{
                      textShadow: "0.3px 0.3px 0 black",
                    }}
                  >
                    <tr>
                      <th
                        className="py-3 px-4 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {tableHeaders.srNo[selectedLang]}
                      </th>
                      <th
                        className="py-3 px-4 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {tableHeaders.division[selectedLang]}
                      </th>
                      <th
                        className="py-3 px-4"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {tableHeaders.monument[selectedLang]}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {stage2Data.map((item, index) => (
                      <tr key={item.id}>
                        <td
                          className="py-3 px-4 border-t-2 border-r-2"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          {selectedLang === "मराठी"
                            ? convertToMarathiNumber(index + 1)
                            : `${index + 1}`}
                          .
                        </td>
                        <td
                          className="py-3 px-4 border-t-2 border-r-2"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          {item.division[selectedLang]}
                        </td>
                        <td
                          className="py-3 px-4 border-t-2 whitespace-pre-line"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          {item.monument[selectedLang]}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Download */}
            <h2 className="text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-8 mt-12">
              {t.download}
            </h2>
            <div className="max-w-4xl mx-auto no-dark-bg">
              <div
                className="bg-[#EFEDE0] rounded-xl overflow-x-auto"
                style={{ border: "2px solid #F8D6BF" }}
              >
                <table className="min-w-full text-center text-black text-sm sm:text-base">
                  <thead
                    className="font-bold tracking-wide"
                    style={{
                      textShadow: "0.3px 0.3px 0 black",
                    }}
                  >
                    <tr>
                      <th
                        className="py-3 px-4 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {tableHeaders.srNo[selectedLang]}
                      </th>
                      <th
                        className="py-3 px-4 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {tableHeaders.scheme[selectedLang]}
                      </th>
                      <th
                        className="py-3 px-4"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {tableHeaders.download[selectedLang]}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {downloadData.map((item, index) => (
                      <tr key={item.id} className="hover:bg-[#F6F6EC]">
                        <td
                          className="py-3 px-4 border-t-2 border-r-2"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          {selectedLang === "मराठी"
                            ? convertToMarathiNumber(index + 1)
                            : `${index + 1}`}
                          .
                        </td>
                        <td
                          className="py-3 px-4 border-t-2 border-r-2"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          {item.schemas[selectedLang]}
                        </td>
                        <td
                          className="py-3 px-4 border-t-2"
                          style={{ borderColor: "#F8D6BF" }}
                        >
                          <a
                            href={item.download}
                            download
                            title="Download PDF"
                            className="text-red-600 hover:text-red-800 flex justify-center"
                          >
                            <FaFilePdf size={20} />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "adopt" && (
        <div className="text-left mx-auto md:mx-16 ">
          <h3 className="text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-8 mt-12">
            {t.heading1}
          </h3>
          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify mb-4 font-futura">
            {t.paragraph4}
          </p>
          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify mb-4 font-futura">
            {t.paragraph5}
          </p>
          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify mb-4 font-futura">
            {t.paragraph6}
          </p>
          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify mb-4 font-futura">
            {t.paragraph7}
          </p>
          <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify mb-4 font-futura">
            {t.paragraph8}
          </p>
          <h2 className="text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-8 mt-16">
            {t.download}
          </h2>
          
          <div className="max-w-4xl mx-auto">
            <div
              className="bg-[#EFEDE0] rounded-xl overflow-x-auto"
              style={{ border: "2px solid #F8D6BF" }}
            >
              <table className="min-w-full text-center text-black text-sm sm:text-base">
                <thead
                  className="font-bold tracking-wide"
                  style={{
                    textShadow: "0.3px 0.3px 0 black",
                  }}
                >
                  <tr>
                    <th
                      className="py-3 px-4 border-r-2"
                      style={{ borderColor: "#F8D6BF" }}
                    >
                      {tableHeaders.srNo[selectedLang]}
                    </th>
                    <th
                      className="py-3 px-4 border-r-2"
                      style={{ borderColor: "#F8D6BF" }}
                    >
                      {tableHeaders.scheme[selectedLang]}
                    </th>
                    <th
                      className="py-3 px-4"
                      style={{ borderColor: "#F8D6BF" }}
                    >
                      {tableHeaders.download[selectedLang]}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {schemasData.map((item) => (
                    <tr key={item.id} className="hover:bg-[#F6F6EC]">
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {item.id}.
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {item.schemas}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        <a
                          href={item.download}
                          download
                          title="Download PDF"
                          className="text-red-600 hover:text-red-800 flex justify-center"
                        >
                          <FaFilePdf size={20} />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Scheme;
